import { useTranslation } from 'react-i18next';

import { useAlertDialog } from '@/components/ui/alert-dialog';
import api from '@/services/api/api';
import PermissionData from '@/types/Permission/PermissionData';
import { useMutation } from '@tanstack/react-query';

export const useDeletePermissionMutation = () => {
  const { alert } = useAlertDialog();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (data: PermissionData) => {
      if (!data?.id) return alert({ title: t('record-not-found'), type: 'error' });
      const response = await api.delete(`admin/permission/${data.id}`);
      return response.data;
    },
    mutationKey: ['deletePermission'],
  });
};
